import React, { useEffect, useRef } from "react";
import { micLevel } from "../agent/voice";

const BARS = 9;
// Each bar reacts to a different slice of the level so the row moves like a
// voice rather than a single block rising and falling together.
const WEIGHTS = [0.35, 0.55, 0.8, 1, 0.85, 1, 0.75, 0.5, 0.3];

/**
 * Listening indicator: a waveform that follows the mic while listening and
 * runs its own colour wave while the copilot speaks. Live transcript sits
 * beside it, so the composer never shows the same words twice.
 */
const VoiceOrb = ({ state, transcript, onStop }) => {
  const barsRef = useRef(null);
  const rafRef = useRef(0);
  const smooth = useRef(0);

  useEffect(() => {
    if (state !== "listening") return undefined;
    const paint = () => {
      const el = barsRef.current;
      if (el) {
        // Attack fast, release slow: speech looks alive, silence settles.
        const level = micLevel();
        smooth.current = level > smooth.current ? level : smooth.current * 0.88 + level * 0.12;
        const jitter = 0.75 + Math.random() * 0.5;
        el.style.setProperty("--level", (smooth.current * jitter).toFixed(3));
      }
      rafRef.current = requestAnimationFrame(paint);
    };
    paint();
    return () => cancelAnimationFrame(rafRef.current);
  }, [state]);

  if (state === "off") return null;

  return (
    <div className={`copilotWave copilotWave--${state}`}>
      <div className="copilotWave__bars" ref={barsRef} aria-hidden="true">
        {WEIGHTS.slice(0, BARS).map((weight, i) => (
          <span
            key={`bar_${i + 1}`}
            className="copilotWave__bar"
            style={{ "--weight": weight, "--i": i }}
          />
        ))}
      </div>
      <div className="copilotWave__text">
        {transcript ? (
          <span className="copilotWave__heard">{transcript}</span>
        ) : (
          <span className="copilotWave__hint">
            {state === "speaking" ? "Speaking" : "Listening"}
          </span>
        )}
      </div>
      <button type="button" className="copilotWave__stop" onClick={onStop}>
        Stop
      </button>
    </div>
  );
};

export default VoiceOrb;
